import { bool, shape, string } from 'prop-types';

const trackingEventShape = shape({
  loadId: string,
  eventId: string,
  eventTime: string,
  eventType: string,
  newTLStatus: string,
  oldTLStatus: string,
  initiatorName: string,
  note: string,
  driverCity: string,
  driverState: string,
  isAutomated: bool,
});

export default trackingEventShape;
